export default __webpack_public_path__ + "static/media/doctor-patient.1997e53d.svg";